/* COY (5 NOV): desktop scroll guard for open drawers (search, cart, menu, filters).
   On desktop these overlays no longer lock the page's overflow (that caused the page to jump),
   so a wheel scroll over empty space used to scroll the page behind. This only decides where a
   wheel scroll goes while an overlay is open: inside a scrollable area of the drawer it scrolls
   that area as normal; anywhere else it is ignored. It never changes layout, sizes or classes.
   Phones keep their normal lock and are not affected. Rollback: delete this file and its <script>. */
(function () {
  var LOCKS = ['overflow-hidden', 'overflow-hidden-drawer', 'coy-mn-locked'];
  var desktop = window.matchMedia('(min-width: 990px)');

  function overlayOpen() {
    var b = document.body;
    if (!b) return false;
    for (var i = 0; i < LOCKS.length; i++) if (b.classList.contains(LOCKS[i])) return true;
    return false;
  }

  function canScroll(el, dy) {
    var oy = getComputedStyle(el).overflowY;
    if (oy !== 'auto' && oy !== 'scroll' && oy !== 'overlay') return false;
    if (el.scrollHeight <= el.clientHeight + 1) return false;
    if (dy < 0) return el.scrollTop > 0;
    return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
  }

  document.addEventListener('wheel', function (e) {
    if (!desktop.matches || !overlayOpen() || e.ctrlKey) return;
    var dy = e.deltaY;
    if (!dy) return;
    var el = e.target instanceof Element ? e.target : null;
    while (el && el !== document.body && el !== document.documentElement) {
      if (canScroll(el, dy)) return;
      el = el.parentElement;
    }
    e.preventDefault();
  }, { passive: false });
})();
